<template>
  <div style="position: relative;">
    <CHeader fixed with-subheader light id="bigcontainer">
      <div class="nav-section">
        <router-link to="/">
          <img
            src="@/assets/logo_no_r.svg"
            class="d-inline-block align-top"
            alt="NeuroLeap Corp"
          />
        </router-link>
      </div>

      <div id="navMiddle-container" class="nav-section d-md-down-none">
        <button class="navbar-button" @click="routing('/')">
          Home
        </button>
        <button class="navbar-button" @click="routing('/aboutUs')">
          About Us
        </button>
        <button class="navbar-button" @click="routing('/reportsStatistics')">
          Reports/Statistics
        </button>
        <button class="navbar-button" @click="routing('/rolesPage')">
          Roles
        </button>
        <button class="navbar-button" @click="routing('/rolesPage/searchAppAdminApps/viewAppAdminApps')">
          App Admin
        </button>
        <button class="navbar-button" @click="routing('/rolesPage/viewAllApplications')">
          Marketplace
        </button>
        <button  v-if="isSuperAdmin" class="navbar-button" @click="routing('/userManagePage')">
          Manage User
        </button>
      </div>

      <div style="padding: 0;" class="nav-section d-md-down-none">
  <!--       <div id="searchApp-container">
          <font-awesome-icon :icon="['fas', 'magnifying-glass']" style="margin: 0 5px;" />
          <input id="searchApp" placeholder="Search" style="display: inline-block;" />
        </div> -->
        <button v-if="!getEmail()" @click="routing('/login')" class="login-signup-buttons navbar-button">
          Login
        </button>
        <button v-if="!getEmail()" @click="routing('/register')" class="login-signup-buttons navbar-button">
          Sign up
        </button>
        <div v-if="getEmail()" style="position: relative;">
          <button id="account-button" @click="toggleAccountDropdown('account-button-dropdown')">
            <div>
              {{ getEmail() }}
            </div>
          </button>
          <div id="account-button-dropdown" class="account-dropdown">
            <div>
              <button @click="routing('/dashboard')">Dashboard</button>
              <button @click="routing('/activities')">Activities</button>
              <button @click="routing('/rolesPage/searchAppAdminApps/viewAppAdminApps/newAppCard')">New Application</button>
              <hr v-if="isSuperuser">
              <button v-if="isSuperuser" @click="routing('/updateUserLevel')">Manage Users</button>
              <hr>
              <button @click="logout">Logout</button>
            </div>
          </div>
        </div>
      </div>
      <div class="nav-section d-lg-none">
        <svg @click="mobileDropDownToggle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>
      </div>
    </CHeader>

    <div id="small-screen-dropdown" class="d-lg-none">
      <div>
        <button v-if="!getEmail()" @click="routing('/login')" class="login-signup-buttons navbar-button">
          Login
        </button>
        <button v-if="!getEmail()" @click="routing('/register')" class="login-signup-buttons navbar-button">
          Sign up
        </button>
        <button class="navbar-button" @click="routing('/')">
          Home
        </button>
        <button class="navbar-button" @click="routing('/aboutUs')">
          About Us
        </button>
        <button class="navbar-button" @click="routing('/reportsStatistics')">
          Reports/Statistics
        </button>
        <button class="navbar-button" @click="routing('/rolesPage')">
          Roles
        </button>
        <button class="navbar-button" @click="routing('/rolesPage/searchAppAdminApps/viewAppAdminApps')">
          App Admin
        </button>
        <button class="navbar-button" @click="routing('/rolesPage/viewAllApplications')">
          Marketplace
        </button>
        <button  v-if="isSuperAdmin" class="navbar-button" @click="routing('/userManagePage')">
          Manage User
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #bigcontainer {
    $nav-padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100dvw;
    height: globalSharedVariables.$navbar-height;
    margin: 0;
    font-weight: 700;
    font-size: 1rem;
    color: #000000;
    padding: $nav-padding;
    background-color: rgba(255, 255, 255, 1);

    svg {
      height: calc(#{globalSharedVariables.$navbar-height} - 2 * #{$nav-padding} - 20px);
    }

    img {
      height: calc(#{globalSharedVariables.$navbar-height} - 2 * #{$nav-padding});
    }
    
    .nav-section {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    #searchApp-container {
      box-shadow: 0 0 5px 0 lightgrey;
      border-radius: 50rem;
      border: solid 1px globalSharedVariables.$orange-1;
      padding: 5px 10px;
      background-color: white;

      input {
        border: none;
        box-shadow: none;
        width: 75%;
      }

      #searchApp {
        font-size: 1rem;

        &:focus {
          border: 0;
          outline: 0;
        }

        &::placeholder {
          text-align: center;
        }
      }
    }

    .login-signup-buttons {
      white-space: nowrap;
      margin: 0 5px;
      width: 6rem;
    }

    .account-dropdown {
      display: none;
      position: fixed;
      top: globalSharedVariables.$navbar-height;
      right: 1.1rem;
      background-color: #FFFFFF;
      border: solid 1px #DFDFDF;
      padding: .75rem;
      border-radius: .5rem;

      hr {
        border-top: 1px solid #D8DBE0;
        border-radius: 50rem;
        opacity: 1;
        margin: 5px 0;
      }
    }

    #navMiddle-container {
      flex-grow: 1;
      display: flex;
      justify-content: center;
      align-items: center;

      > button {
        margin: 0 5px;
      }
    }

    #account-button-dropdown {
      button {
        display: block;
        margin: 5px 0;
      }
    }
  }

  #small-screen-dropdown {
    position: fixed;
    top: globalSharedVariables.$navbar-height;
    z-index: 51;
    background-color: white;
    width: 100%;
    overflow: hidden;
    height: 0;
    transition: height .15s ease;
    max-height: calc(100vh - #{globalSharedVariables.$navbar-height});
    overflow: auto;
    
    &.show {
      box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
    }

    > div {
      padding: 1rem;
    }

    button {
      margin: 5px 0;
      display: block;
    }
  }

</style>

<script>
  import instance from "../axios.js";

  export default {
    name: "NavigationBar",
    data() {
      return {
        searchTerm: "",
      };
    },
    mounted() {
      document.addEventListener('click', this.handleOutsideNavDropDownClick);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.handleOutsideNavDropDownClick);
    },
    computed: {
      displayWebsite() {
        return this.$store.getters.isLoggedIn;
      },
      isSuperuser() {
        return this.$store.getters.getUserLevel === 'Super Admin' ? true : false;
      },
      isSuperAdmin() {
        var user_role = this.$store.getters.getUserLevel;
        if (user_role == "Super Admin" || user_role == "Developer") {
          return true;
        }
        return false;
      },
    },

    methods: {
      routing(url) {
        this.$router.push(url);
      },
      getEmail() {
        var email = this.$store.getters.getCurrentEmail;

        if (email) {
          return email;
        } else {
          return null;
        }
      },
      async logout() {
        try {
          await instance.post(`api/auth/logout`, {});
          this.$store.commit("setUserLevel", null);
          this.$store.commit("setAuthUser", null);
          this.$store.commit("setCurrentEmail", null);

          this.$router.push("/");
        } catch (e) {
          console.error(e);
        }
      },
      toggleAccountDropdown(id) {
        let ref = document.getElementById(id);
        if (ref.style.display == 'block') {
          ref.style.display = 'none';
        } else {
          ref.style.display = 'block';
        }
      },
      handleOutsideNavDropDownClick(e) {
        if (this.getEmail()) {
          if (!(document.getElementById('account-button')).contains(e.target)) {
            document.getElementById('account-button-dropdown').style.display = 'none';
          }
        }
      },
      mobileDropDownToggle() {
        let ref = document.getElementById('small-screen-dropdown');
        ref.classList.toggle('show');
        if (ref.classList.contains('show')) {
          ref.style.height = ref.scrollHeight + 'px';
        } else {
          ref.style.height = 0;
        }
      }
    },
  };
</script>
